import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { PickerModule } from '@ctrl/ngx-emoji-mart'
import { SharedModule } from 'lib-trend-core'
import { WaTemplateModule } from '../wa-template/wa-template.module'
import { WaWebhookTemplateModule } from '../wa-template/webhook-integration-wa-template/webhook-integrations-wa-template.module'
import { RcsMessageModule } from '../rcs-message/rcs-message.module'
import { AgendorFormComponent } from './agendor-integrations/agendor-integration-form/agendor-integration-form.component'
import { AgendorListComponent } from './agendor-integrations/agendor-integration-list/agendor-integration-list.component'
import { IntegrationsRoutingModule } from './integrations-routing.module'
import { IntegrationsComponent } from './integrations.component'
import { PipedriveFormComponent } from './pipedrive-integrations/pipedrive-integration-form/pipedrive-integration-form.component'
import { PipedriveListComponent } from './pipedrive-integrations/pipedrive-integration-list/pipedrive-integration-list.component'
import { SantriIntegrationsItemComponent } from './santri-integrations/santri-integration-item/santri-integrations-item.component'
import { SantriIntegrationsFormComponent } from './santri-integrations/santri-integrations-form/santri-integrations-form.component'
import { SantriIntegrationsListComponent } from './santri-integrations/santri-integrations-list/santri-integrations-list.component'
import { TrendGPTAgentsFormComponent } from './trendgpt-integration/trendgpt-integration-agents-form/trendgpt-integration-agents-form.component'
import { TrendGPTAgentsComponent } from './trendgpt-integration/trendgpt-integration-agents/trendgpt-integration-agents.component'
import { WebhookIntegrationsItemComponent } from './webhook-integrations/webhook-integration-item/webhook-integrations-item.component'
import { WebhookIntegrationsFormComponent } from './webhook-integrations/webhook-integrations-form/webhook-integrations-form.component'
import { WebhookIntegrationsListComponent } from './webhook-integrations/webhook-integrations-list/webhook-integrations-list.component'
import { WebhookIntegrationsRequestsViewComponent } from './webhook-integrations/webhook-integrations-requests-view/webhook-integrations-requests-view.component'
import { WebhookIntegrationsRequestsComponent } from './webhook-integrations/webhook-integrations-requests/webhook-integrations-requests.component'
import { WebhookTestModalComponent } from './webhook-integrations/webhook-test-modal/webhook-test-modal.component'

@NgModule({
  imports: [
    IntegrationsRoutingModule,
    WaWebhookTemplateModule,
    PickerModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    WaTemplateModule,
    RcsMessageModule,
  ],
  declarations: [
    IntegrationsComponent,
    WebhookIntegrationsListComponent,
    WebhookIntegrationsFormComponent,
    WebhookIntegrationsItemComponent,
    WebhookIntegrationsRequestsComponent,
    WebhookIntegrationsRequestsViewComponent,
    PipedriveFormComponent,
    PipedriveListComponent,
    AgendorFormComponent,
    AgendorListComponent,
    SantriIntegrationsFormComponent,
    SantriIntegrationsItemComponent,
    SantriIntegrationsListComponent,
    TrendGPTAgentsComponent,
    TrendGPTAgentsFormComponent,
    WebhookTestModalComponent
  ],
  providers: [
  ]
})
export class IntegrationsModule { }
